import { render, staticRenderFns } from "./MyFeedHeader.vue?vue&type=template&id=3fa076b6&scoped=true&"
import script from "./MyFeedHeader.vue?vue&type=script&lang=js&"
export * from "./MyFeedHeader.vue?vue&type=script&lang=js&"
import style0 from "./MyFeedHeader.vue?vue&type=style&index=0&id=3fa076b6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fa076b6",
  null
  
)

export default component.exports